import { useEnhancedRouter } from '@/hooks/useEnhancedRouter';
import cn from 'classnames';
import { MouseEvent } from 'react';
import styles from './Tag.module.scss';

type TagProps = {
  text: string;
  className?: string;
  link?: string;
};

export function Tag({ text, className, link }: TagProps) {
  const { push } = useEnhancedRouter();

  const tagClassName = cn(
    styles.tag,
    {
      [styles.pointer]: link,
    },
    className,
    'custom-tag',
  );

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    if (link) {
      push(link);
    }
  };

  return (
    <div className={tagClassName} onClick={handleClick}>
      {text}
    </div>
  );
}
